import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";
import { DEFAULT_SETTINGS } from "../lib/site";

const SiteContext = createContext(null);

export const SiteProvider = ({ children }) => {
  const [settings, setSettings] = useState(DEFAULT_SETTINGS);
  const [services, setServices] = useState([]);
  const [gallery, setGallery] = useState([]);
  const [reviews, setReviews] = useState([]);
  const [loaded, setLoaded] = useState(false);

  const refresh = useCallback(async () => {
    try {
      const [s, sv, g, rv] = await Promise.all([api.get("/settings"), api.get("/services"), api.get("/gallery"), api.get("/reviews")]);
      setSettings({ ...DEFAULT_SETTINGS, ...s.data });
      setServices(sv.data);
      setGallery(g.data);
      setReviews(rv.data);
    } finally {
      setLoaded(true);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return (
    <SiteContext.Provider value={{ settings, services, gallery, reviews, loaded, refresh }}>{children}</SiteContext.Provider>
  );
};

export const useSite = () => useContext(SiteContext);
